import { useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./css/Children.module.css";
import { getSession, jwtDecode } from "../auth/auth.utils";
// import { UserHeader } from "../components/UserHeader";
import { Paths } from "../routes/paths";
import { baseURL } from "../services/axios";


/**
 * עמוד להוספת ילד חדש למערכת
 */
export const AddChildPage = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    id: "",
    fname: "",
    lname: "",
    birthday: "",
    gender: "",
    email: "",
    address: "",
    childsDisability: "",
    familyPosition: "",
    educationalInstitution: ""
  });
  const [errorMessage, setErrorMessage] = useState("");

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErrorMessage("");
    
    const token = getSession();
    const decoded = token ? jwtDecode(token) : null;
    const analystId = decoded?.["code"];

    if (!analystId) {
      setErrorMessage("שגיאה: לא נמצא קוד אנליסט בטוקן.");
      return;
    }

    const payload = {
      ...formData,
      lessonNumber: 0,
      analystId: Number(analystId)
    };

    try {
      const response = await fetch(`${baseURL}/child`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(payload)
      });

      if (response.ok) {
        navigate(`/${Paths.analystArea}`);
      } else {
        const error = await response.text();
        setErrorMessage("שגיאה בהוספה: " + error);
      }
    } catch (error) {
      console.error(error);
      setErrorMessage("שגיאה בקליינט. נסה שוב מאוחר יותר.");
    }
  };

  return (
    <>
      {/* <UserHeader /> */}
      <div className={styles.pageContainer} style={{ backgroundColor: 'transparent', padding: '30px 0' }}>
        <div className={styles.card} style={{ 
          maxWidth: '900px', 
          margin: '30px auto',
          padding: '35px 40px',
          borderRadius: '20px',
          boxShadow: 'none',
          backgroundColor: 'transparent',
        }}>
          <h1 className={styles.title} style={{
            fontSize: '2.2rem',
            marginBottom: '30px',
            color: '#471f1f',
            textAlign: 'center',
            fontWeight: 600,
            position: 'relative',
            paddingBottom: '15px'
          }}>
            הוספת ילד חדש
            <span style={{
              position: 'absolute',
              bottom: 0,
              left: '50%',
              transform: 'translateX(-50%)',
              width: '100px',
              height: '3px',
              background: 'linear-gradient(to right, #a2b087, #ba9484)',
              borderRadius: '2px',
              display: 'block'
            }}></span>
          </h1>
          <form onSubmit={handleSubmit} style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: '25px',
            maxWidth: '800px',
            margin: '0 auto'
          }}>
            <div className={styles.formGroup}>
              <label htmlFor="id" style={{
                fontWeight: 'bold',
                color: '#471f1f',
                marginBottom: '8px',
                display: 'block'
              }}>תעודת זהות:</label>
              <input 
                id="id" 
                name="id" 
                placeholder="הזן תעודת זהות" 
                value={formData.id} 
                onChange={handleChange} 
                required 
                className={styles.input}
                style={{
                  padding: '12px 15px',
                  borderRadius: '10px',
                  border: '1px solid #e0e0e0',
                  fontSize: '1.05rem',
                  width: '100%',
                  transition: 'all 0.3s ease'
                }}
              />
            </div>
            <div className={styles.formGroup}>
              <label htmlFor="fname" style={{
                fontWeight: 'bold',
                color: '#471f1f',
                marginBottom: '8px',
                display: 'block'
              }}>שם פרטי:</label>
              <input 
                id="fname" 
                name="fname" 
                placeholder="הזן שם פרטי" 
                value={formData.fname} 
                onChange={handleChange} 
                required 
                className={styles.input}
                style={{
                  padding: '12px 15px',
                  borderRadius: '10px',
                  border: '1px solid #e0e0e0',
                  fontSize: '1.05rem',
                  width: '100%',
                  transition: 'all 0.3s ease'
                }}
              />
            </div>
            <div className={styles.formGroup}>
              <label htmlFor="lname" style={{
                fontWeight: 'bold',
                color: '#471f1f',
                marginBottom: '8px',
                display: 'block'
              }}>שם משפחה:</label>
              <input 
                id="lname" 
                name="lname" 
                placeholder="הזן שם משפחה" 
                value={formData.lname} 
                onChange={handleChange} 
                required 
                className={styles.input}
                style={{
                  padding: '12px 15px',
                  borderRadius: '10px',
                  border: '1px solid #e0e0e0',
                  fontSize: '1.05rem',
                  width: '100%',
                  transition: 'all 0.3s ease'
                }}
              />
            </div>
            <div className={styles.formGroup}>
              <label htmlFor="birthday" style={{
                fontWeight: 'bold',
                color: '#471f1f',
                marginBottom: '8px',
                display: 'block'
              }}>תאריך לידה:</label>
              <input 
                id="birthday" 
                type="date" 
                name="birthday" 
                value={formData.birthday} 
                onChange={handleChange} 
                required 
                className={styles.input}
                style={{
                  padding: '12px 15px',
                  borderRadius: '10px',
                  border: '1px solid #e0e0e0',
                  fontSize: '1.05rem',
                  width: '100%',
                  transition: 'all 0.3s ease'
                }}
              />
            </div>
            <div className={styles.formGroup}>
              <label htmlFor="gender" style={{
                fontWeight: 'bold',
                color: '#471f1f',
                marginBottom: '8px',
                display: 'block'
              }}>מין:</label>
              <input 
                id="gender" 
                name="gender" 
                placeholder="זכר / נקבה" 
                value={formData.gender} 
                onChange={handleChange} 
                className={styles.input}
                style={{
                  padding: '12px 15px',
                  borderRadius: '10px',
                  border: '1px solid #e0e0e0',
                  fontSize: '1.05rem',
                  width: '100%',
                  transition: 'all 0.3s ease'
                }}
              />
            </div>
            <div className={styles.formGroup}>
              <label htmlFor="email" style={{
                fontWeight: 'bold',
                color: '#471f1f',
                marginBottom: '8px',
                display: 'block'
              }}>אימייל:</label>
              <input 
                id="email" 
                name="email" 
                placeholder="הזן כתובת דוא״ל" 
                value={formData.email} 
                onChange={handleChange} 
                className={styles.input}
                style={{
                  padding: '12px 15px',
                  borderRadius: '10px',
                  border: '1px solid #e0e0e0',
                  fontSize: '1.05rem',
                  width: '100%',
                  transition: 'all 0.3s ease'
                }}
              />
            </div>
            <div className={styles.formGroup}>
              <label htmlFor="address" style={{
                fontWeight: 'bold',
                color: '#471f1f',
                marginBottom: '8px',
                display: 'block'
              }}>כתובת:</label>
              <input 
                id="address" 
                name="address" 
                placeholder="הזן כתובת מגורים" 
                value={formData.address} 
                onChange={handleChange} 
                className={styles.input}
                style={{
                  padding: '12px 15px',
                  borderRadius: '10px',
                  border: '1px solid #e0e0e0',
                  fontSize: '1.05rem',
                  width: '100%',
                  transition: 'all 0.3s ease'
                }}
              />
            </div>
            <div className={styles.formGroup}>
              <label htmlFor="childsDisability" style={{
                fontWeight: 'bold',
                color: '#471f1f',
                marginBottom: '8px',
                display: 'block'
              }}>לקות הילד:</label>
              <input 
                id="childsDisability" 
                name="childsDisability" 
                placeholder="פרט את לקות הילד" 
                value={formData.childsDisability} 
                onChange={handleChange} 
                className={styles.input}
                style={{
                  padding: '12px 15px',
                  borderRadius: '10px',
                  border: '1px solid #e0e0e0',
                  fontSize: '1.05rem',
                  width: '100%',
                  transition: 'all 0.3s ease'
                }}
              />
            </div>
            <div className={styles.formGroup}>
              <label htmlFor="familyPosition" style={{
                fontWeight: 'bold',
                color: '#471f1f',
                marginBottom: '8px',
                display: 'block'
              }}>מיקום במשפחה:</label>
              <input 
                id="familyPosition" 
                name="familyPosition" 
                placeholder="בכור / אמצעי / צעיר" 
                value={formData.familyPosition} 
                onChange={handleChange} 
                className={styles.input}
                style={{
                  padding: '12px 15px',
                  borderRadius: '10px',
                  border: '1px solid #e0e0e0',
                  fontSize: '1.05rem',
                  width: '100%',
                  transition: 'all 0.3s ease'
                }}
              />
            </div>
            <div className={styles.formGroup}>
              <label htmlFor="educationalInstitution" style={{
                fontWeight: 'bold',
                color: '#471f1f',
                marginBottom: '8px',
                display: 'block'
              }}>מוסד לימודים:</label>
              <input 
                id="educationalInstitution" 
                name="educationalInstitution" 
                placeholder="שם בית הספר / הגן" 
                value={formData.educationalInstitution} 
                onChange={handleChange} 
                className={styles.input}
                style={{
                  padding: '12px 15px',
                  borderRadius: '10px',
                  border: '1px solid #e0e0e0',
                  fontSize: '1.05rem',
                  width: '100%',
                  transition: 'all 0.3s ease'
                }}
              />
            </div>
            
            <div className={styles.buttonContainer} style={{
              marginTop: '30px',
              display: 'flex',
              justifyContent: 'center',
              gap: '20px',
              gridColumn: '1 / -1'
            }}>
              <button 
                type="submit" 
                className={styles.button}
                style={{
                  padding: '14px 32px',
                  fontSize: '1.05rem',
                  background: 'linear-gradient(135deg, #a2b087 0%, #ba9484 100%)',
                  color: 'white',
                  border: 'none',
                  borderRadius: '12px',
                  cursor: 'pointer',
                  fontWeight: 'bold',
                  transition: 'all 0.3s ease',
                  boxShadow: '0 4px 15px rgba(162, 176, 135, 0.3)'
                }}
              >
                שמור ילד
              </button>
              <button 
                type="button" 
                className={styles.buttonSecondary} 
                onClick={() => navigate(`/${Paths.analystChildren}`)}
                style={{
                  padding: '14px 32px',
                  fontSize: '1.05rem',
                  backgroundColor: 'transparent',
                  color: '#a2b087',
                  border: '2px solid #a2b087',
                  borderRadius: '12px',
                  cursor: 'pointer',
                  fontWeight: 'bold',
                  transition: 'all 0.3s ease',
                  boxShadow: 'none'
                }}
              >
                ביטול
              </button>
            </div>
            {errorMessage && (
              <p className={styles.error} style={{
                color: '#e74c3c',
                textAlign: 'center',
                marginTop: '15px',
                fontSize: '1.05rem',
                gridColumn: '1 / -1'
              }}>{errorMessage}</p>
            )}
          </form>
        </div>
      </div>
    </>
  );
};
